export const referenceCardSelectedPagRefName = 'referenceCardSelectedPagRef';

export const referenceCardSelectedPagRefProjection = `{
  _id,
  _type,
  wistiaVideoMetadata,
  "cardImage": coalesce(
    select(defined(cardImage.asset) => cardImage),
    select(defined(genericCardImage.asset) => genericCardImage),
    select(defined(baseCardImage.asset) => baseCardImage),
    select(defined(heroImage.asset) => heroImage),
  ),
  currentPathname,
  title,
  cardButtonText,
  description,
  "articleDate": coalesce(articleDate, startDateTime.utc),
  _type in ['lumaEvent', 'linkedEvent'] => {
    "title": name,
    "currentPathname": url,
    "articleDate": startDateTime.utc,
  },
}`;

export const referenceCardSelectedPagRefQuery = groq`*[_id == $_id][0] ${referenceCardSelectedPagRefProjection}`;
